// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"buttonWrapper__VQkRF","supportModal":"supportModal__20rr2"};